import ApiService from "@services/api.service";
import { Notify } from 'quasar'

export const sessionDocuments = {
  state: {
    documents: [],
  },
  mutations: {
    setSessionDocuments(state, documents) {
      state.documents = documents;
    },
  },
  actions: {
    async fetchDocumentsSession(context, { sessionId, sessionType }) {
      try {
        const response = await ApiService.getRequest(
          `get_documents_session/${sessionId}?type=${sessionType}`
        )
        context.commit('setSessionDocuments', response.data.documents)
        return response.data.documents
      } catch (e) {
        console.error(e)
        Notify.create({
          message: "Impossible de récupérer les documents de la session",
          color: 'red'
        })
      }
    },
  },
  getters: {
    getSessionDocuments(state) {
      return state.documents;
    },
  }
}
